export const applicationBlue = {
  500: "#5D90CB",
  700: "#3c7ec9",
  900: "#1d4c82",
};

export const applicationGreen = {
  500: "#649C69",
  700: "#45994c",
  900: "#1b6922",
};

export const applicationPurple = {
  500: "#9c608e",
  700: "#8f5782",
  900: "#521744",
};
